import wordBank from "./Components/Wordbank.txt";

export const boardDefault = [
  ["", "", "", "", ""],
  ["", "", "", "", ""],
  ["", "", "", "", ""],
  ["", "", "", "", ""],
  ["", "", "", "", ""],
  ["", "", "", "", ""],
];

export const generateWordSet = async () => {
  let wordSet;
  let theWord;
  await fetch(wordBank)
    .then((response) => response.text())
    .then((result) => {
      const wordArr = result.split("\n");
      const startDate = new Date('October 29, 2024 00:00:00');
      const today = new Date();
      const timeDifference = today - startDate;
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      theWord = wordArr[daysDifference % wordArr.length];
      wordSet = new Set(wordArr);
    });
  return { wordSet, theWord };
};